import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';
import { ManagementComponent } from '../management.component';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-offer-requests',
  templateUrl: './offer-requests.component.html',
  styleUrls: ['./offer-requests.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class OfferRequestsComponent implements OnInit {

  constructor(private parent:ManagementComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

     // Debounce search.
     this.searchMainOrders.pipe(
      debounceTime(750),
      distinctUntilChanged())
      .subscribe(value => {
        this.LoadingMainSearchTerm = true;

        this.InitializeFilter();
        this.DisablePeriod();
        this.ClearPeriod();

        this.Filter.SearchTerm = value;
        this.GetOrdersFiltered(1);
      });

      // Debounce search.
      this.searchB2BUser.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetUserClientsFiltered(value);
        });

          // Debounce search.
     this.searchUserManagerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetUserManagersFiltered(value);
      });

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, null, true);
      });
  
     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.GetOrdersFiltered(this.Filter.Pager.PageIndex = 1);
        }
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  searchPartnerUpdate = new Subject<string>();
  searchUserManagerUpdate = new Subject<string>();
  searchB2BUser = new Subject<string>();
  searchMainOrders = new Subject<string>();

  LoadingMainSearchTerm:boolean = false;

  searchMainOrdersSearchTerm:string;

  ngOnInit(): void {
    this.InitializeFilter();
    this.GetOfferRequestMasterData();
  }

  countryID:number = null;
  Filter: {[k: string]: any} = {};
  MasterData: {[k: string]: any} = {};
  CurrentShippingAddress:any;
  activeFilters:{[k: string]: any} = [];
  Orders:{[k: string]: any} = [];
  Totals:{[k: string]: any} = [];
  searchTerm:string;
  Partners:any[];
  resultsLength:number = 0;
  partner:any;
  CurrentOrder:any;
  UserClientsSearchTerm:string;

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  loadingOrders:boolean;
  showFilter:boolean;
  ShowExportBulkQuestion:boolean;
  AllSelected:boolean;
  ShowOrderCancelation:boolean;
  ShowOrderCopy:boolean;
  ShowEditContainer:boolean;

  SearchUserManager:string;
  UserManagers:any[];
  UserManagersLength:number = 0;
  UserManager:any;

  SearchUserUploader:string;
  UserClients:any[];
  UserClientsLength:number = 0;
  UserUploader:any;

  ShowOrderBillingInformation:boolean = false;
  ShowOrderShippingInformation:boolean = false;
  ShowOrderGeneralInformation:boolean = false;
  ShowOrderProductsInformation:boolean = true;

InitializeFilter(){

  this.Filter = {};
  this.Filter.SearchTerm = "";
  this.Filter.DebatorPO = "";
  this.Filter.MainSearchTerm = "";

  this.Filter.FromDate = null;
  this.Filter.ToDate = null;

  this.Filter.Pager = {};
  this.Filter.Pager.PageIndex = 1;
  this.Filter.Pager.PageSize = 50;
  this.Filter.Pager.TotalCount = 0;

  this.Filter.Partner = {};
  this.Filter.Partner = null;
  
  this.Filter.UserUploader = {};
  this.Filter.UserUploader = null;
  
  this.Filter.UserManager = {};
  this.Filter.UserManager = null;

  this.Filter.Period = {};
  this.Filter.Period = null;

  this.Filter.Country = {};
  this.Filter.Country = null;

  this.Filter.Currency = {};
  this.Filter.Currency = null;

  this.Filter.Company = {};
  this.Filter.Company = null;

  this.Filter.IndividualStatus = {};
  this.Filter.IndividualStatus = null;

  this.Filter.Status = {};
  this.Filter.Status = null;

  this.Filter.TranzactionType = {};
  this.Filter.TranzactionType = null;

  this.Filter.SortingOrder = {};
  this.Filter.SortingOrder = null;
}

ClearPeriod(){
  this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  this.Filter.Period = null;
}

DisablePeriod(){
  this.Filter.Period = null;
  this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
}

GetOfferRequestMasterData(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.parent.loading = true;

  this.B2BService.GetOfferRequestMasterData(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.MasterData = response;
      this.GetOrdersFiltered(1);
    }

    this.parent.loading = false;
   });
}

ResetMainSearch(){
  this.searchMainOrders.next(null);
  this.Filter.SearchTerm = "";
}

GetOrdersFiltered(page = 1){

  this.Filter.Pager.PageIndex = page;

  if(this.Filter.DisplayAllPagesTotals == true){
    this.Filter.ExchangeToTargetCurrency = false;
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
  }
  
  this.loadingOrders = true;
  this.showFilter = false;

  this.B2BService.GetOfferRequestsFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders = response["OfferRequests"];
    this.Totals = response["Totals"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
    
    this.LoadingMainSearchTerm = false;
    this.loadingOrders = false;
  });

  this.GetOrdersFilteredCOUNT();
}

GetOrdersFilteredCOUNT(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
  }

  this.B2BService.GetOfferRequestsFilteredCOUNT(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Filter.Pager = response["Pager"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
 
  });
}

AddActiveFilter(filterName:string, filterType:string){
  var filter = {
    ID:this.parent.newGuid(),
    Name:filterName,
    Type:filterType
  };
  
  if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
    this.showFilter = false;
    this.GetOrdersFiltered();
  }

  this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
  this.activeFilters.push(filter);

  if(filterType == "Period"){
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;

    this.FromDate = new FormControl(moment(this.Filter.FromDate));
    this.ToDate = new FormControl(moment(this.Filter.ToDate));
  }
}

RemoveActiveFilter(ID:string, filterType:string){
  this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

  if(filterType == "Administration"){
    this.Filter.Administration = null;
  }
  else if(filterType == "Series"){
    this.Filter.AccountingSeries = null;
  }
  else if(filterType == "Status"){
    this.Filter.IndividualStatus = null;
  }
  else if(filterType == "DocumentNumber"){
    this.Filter.DocumentNumber = null;
  }
  else if(filterType == "Product"){
    this.Filter.Product = null;
    this.Filter.SearchTerm = null;
  }
  else if(filterType == "Partner"){
    this.Filter.Partner = null;
  }
  else if(filterType == "Period"){
    this.Filter.Period = null;
  }
  else if(filterType == "Country"){
    this.Filter.Country = null;
  }
  else if(filterType == "Currency"){
    this.Filter.Currency = null;
  }
  else if(filterType == "InvoiceDocType"){
    this.Filter.InvoiceDocType = null;
  }
  else if(filterType == "UserManager"){
    this.Filter.UserManager = null;
  }
  else if(filterType == "UserUploader"){
    this.Filter.UserUploader = null;
  }

  this.GetOrdersFiltered();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.Orders.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SelectAll(){
  this.Orders.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
  var request = {
    SearchTerm:searchTerm,
    CountryID:CountryID,
    PageIndex:1,
    PageSize:10,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company
  };

  if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.resultsLength = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.Partners = [];
    this.resultsLength = 0;
  }
}

GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
  var request = {
    SearchTerm:searchTerm,
    CountryID:CountryID,
    PageIndex:1,
    PageSize:50,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company
  };

  if(this.searchTerm.length >= 3){
    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.resultsLength = response["Count"];

       if(this.Partners.length == 1){
        this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
        this.GetOrdersFiltered(1);
       }
      }
   
      this.parent.loading = false;
    });
  }
}

InitializeUserManagersOnClick(searchTerm:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:searchTerm,
  };

  if((searchTerm.length >= 3) && (this.UserManagers == null || this.UserManagers.length == 0)){
    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserManagers = response["Users"];
        this.UserManagersLength = this.UserManagers.length;
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.UserManagers = [];
    this.UserManagersLength = 0;
  }
}

GetUserManagersFiltered(s:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:s,
  };

  this.parent.loading = true;

  this.service.GetUsersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
      this.UserManagers = response["Users"];
      this.UserManagersLength = this.UserManagers.length;
    }
 
    this.parent.loading = false;
  });

}

InitializeUserClientsOnClick(searchTerm:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:searchTerm,
  };

  if((searchTerm.length >= 3) && (this.UserClients == null || this.UserClients.length == 0)){
    this.parent.loading = true;

    this.B2BService.GetB2BUserClients(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserClients = response["Users"];
        this.UserClientsLength = this.UserClients.length;
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.UserClients = [];
    this.UserClientsLength = 0;
  }
}

GetUserClientsFiltered(s:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:s,
  };

  this.parent.loading = true;

  this.B2BService.GetB2BUserClients(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
      this.UserClients = response["Users"];
      this.UserClientsLength = this.UserClients.length;
    }
 
    this.parent.loading = false;
  });

}

ClearUserClients(){
  this.Filter.UserUploader = null;
  this.UserClientsSearchTerm = null;
  this.UserClients = [];
  this.UserClientsLength = 0;
 }

OpenOrderCancelation(o:any){
  this.CurrentOrder = JSON.parse(JSON.stringify(o));
  this.ShowOrderCancelation = true;
}

CancelOrder(o:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:o.DBID,
  };

  this.parent.loading = true;

  this.B2BService.CancelOfferRequest(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders.forEach(order => {
        if(order.DBID == o.DBID){
          order.ProcessingStatus = response["ProcessingStatus"];
          order.OfferRequestStatus = response["OfferRequestStatus"];
        }
      });
    }
 
    this.parent.loading = false;
  });
}

OpenCopyOrder(o:any){
  this.CurrentOrder = JSON.parse(JSON.stringify(o));
  this.ShowOrderCopy = true;
}

CopyOrder(o:any){
  this.GetOfferRequest(o.ID);
}

GetOfferRequest(RequestOfferID:string){
  var request = {
  User:this.parent.User,
  Language:this.parent.getLanguage(),
  RequestOfferID:RequestOfferID,
  GetCartItems:true,
  WithLogs:true,
};

this.parent.loading = true;

this.B2BService.GetOfferRequest(request).subscribe(response => {

  if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.CurrentOrder = response["OfferRequest"];
    this.ShowEditContainer = true;
  }

  this.parent.loading = false;
});

}

PrintOrder(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
  };

  this.parent.loading = true;

  this.B2BService.ExportOfferRequest(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.printPage(Document.Name , Document.PDFStream, Document.ID);
    }

    this.parent.loading = false;
  });
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ExportOrder(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
  };

  this.parent.loading = true;

  this.B2BService.ExportOfferRequest(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.parent.loading = false;
  });
}


printPage(name:string, html:string, ID:string) {
  var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
  + ' type="application/pdf"'
  + ' src="data:application/pdf;base64,'
  + escape(html)
  + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.CurrentOrder.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });
}

AwknowledgeOrder(o:any){
  if(o.ProcessingStatus?.ID == 0){
    this.ChangeOrderStatus(o);
  }
}

ChangeOrderStatus(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:o.DBID,
    ProcessingStatus:this.MasterData.OrderStatuses.filter(x => x.ID == 1)[0],
    Type:o.Type,
    ID:o.ID,
  };

  this.parent.loading = true;

  this.managementService.ChangeOrderStatus(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      o.ProcessingStatus = response["ProcessingStatus"];
    }

    this.parent.loading = false;
  });
}

AskClientStatusNotificationEmail:boolean;

AddNewOfferRequest(){
  if(this.parent.loading != true){
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     OfferRequest:this.CurrentOrder
   };
 
   this.parent.loading = true;
 
   this.B2BService.AddNewOfferRequest(request).subscribe(response => {
 
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      var RFQ = JSON.parse(JSON.stringify(response["OfferRequest"]));
      
      if(RFQ.OfferRequestStatus.ID != this.CurrentOrder.OfferRequestStatus.ID){
        this.AskClientStatusNotificationEmail = true;
      }

      this.Orders.forEach(element => {
        if(element.DBID == RFQ.DBID){
          element.OfferRequestStatus = RFQ.OfferRequestStatus;
        }
      });
     }
 
     this.ShowEditContainer = false;
     this.parent.loading = false;
    });
  }
 }

 ChangeGridCellItem(item:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    item:item,
    Partner:this.CurrentOrder.Cart.Partner,
    Company:this.CurrentOrder.Company,
  };
 
  this.B2BService.ChangeGridCellItem(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["item"];

      this.CurrentOrder.Cart.Items.forEach((cell, index) => {
        if(cell.UIID == item.UIID){
          this.CurrentOrder.Cart.Items[index] = JSON.parse(JSON.stringify(Item));
        }
      });
    }
   });
}

ShowConfirmationQuestion:boolean = false;

PreCheckOfferRequestConfirmation(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    OfferRequest:o,
  };
 
  this.B2BService.PreCheckOfferRequestConfirmation(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 60000);
    }
    else if(response["Status"] == 1){
      this.CurrentOrder = o;
      this.ShowConfirmationQuestion = true;
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 60000);
    }
   });
}

ConfirmOrder(o:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
    DBID:o.DBID,
    OfferRequestStatus:{
      ID:12,
    }
  };
 
  this.B2BService.ChangeOfferRequestStatus(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      o.OfferRequestStatus = JSON.parse(JSON.stringify(response["OfferRequestStatus"]));
      this.SendClientRequestToPendingOrderConfirmation(o);
    }
   });
}

SendClientRequestToPendingOrderConfirmation(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    RequestOfferID:o.ID,
    GetCartItems:true,
    WithLogs:true,
    GetCartItemsPurchaseOfferData:true,
  };
  
  this.parent.loading = true;
  
  this.B2BService.GetOfferRequest(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentOrder = response["OfferRequest"];

      var Sendrequest = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        OfferRequest:JSON.parse(JSON.stringify(this.CurrentOrder)),
      };
     
      this.B2BService.SendClientRequestToPendingOrderConfirmation(Sendrequest).subscribe(response => {
    
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 60000);
        }
        else if(response["Status"] == 1){
    
          var message = JSON.parse(JSON.stringify(response["Message"]));
          if(message?.length > 0){
            this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 60000);
          }

          var InjectionError = JSON.parse(JSON.stringify(response["InjectionError"]));

          this.Orders.forEach(order => {
            if(order.DBID == o.DBID){
              order.InjectionError = JSON.parse(JSON.stringify(InjectionError));
            }
          });
        }

        this.parent.loading = false;
       });
    }
  });
}

SelectItemSupplierVariants(item:any){
  this.CurrentOrder.Cart.Items.forEach(element => {
    if(element.UIID == item.UIID){
      element.IsSelected = !element.IsSelected;
    }
    else{
      element.IsSelected = false;
    }
  });
}
}
